import React from 'react';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectAllEmployees } from '_redux/slices/timeline/employees';
import {
    setClicked,
    setPoints,
    setClickedJob,
    resetFlightContext,
    setClickedFromLocTab,
} from '_redux/slices/utils/menu-context';

// styling
import { Spacing } from '_styles';

// utils
import { getTaskCardStatus } from '_utils/functions';

// single row within the airport location card adhoc task table. handles its own
// right-click to open the shared JobActionMenu so adhoc tasks can be unplanned
const AdhocTaskTableRow = ({ task }) => {
    const dispatch = useDispatch();
    const usedTheme = useSelector(selectUsedTheme);
    const allEmployees = useSelector(selectAllEmployees);

    const { status, borderColor } = getTaskCardStatus(task, true);

    const taskType = task?.adhocTaskInformation?.title
        || task?.adhocTaskInformation?.description
        || 'Adhoc Task';

    const assigned = task?.assignedTime || '';

    const resolveEmployeeName = () => {
        if (task?.employeeName) return task.employeeName;
        if (!task?.employeeId) return 'Unassigned';
        const emp = allEmployees?.find((e) => e?.employeeId === task.employeeId);
        return emp?.title || emp?.name || task.employeeId;
    };

    const employeeName = resolveEmployeeName();

    // right-click: seed the menu-context slice the same way JobCard.handleLeftClick does
    // so the globally-mounted JobActionMenu opens at the cursor with this task selected
    const handleContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch(setClicked(true));
        dispatch(setPoints({ x: e.pageX, y: e.pageY }));
        dispatch(setClickedJob(task));
        dispatch(resetFlightContext());
        dispatch(setClickedFromLocTab(false));
    };

    return (
        <tr
            key={task?._id}
            onContextMenu={handleContextMenu}
            style={{ cursor: 'context-menu' }}
        >
            <td style={tdStyles(usedTheme)} title={taskType}>{taskType}</td>
            <td style={{ ...tdStyles(usedTheme), opacity: task?.employeeId ? 1 : 0.4 }}>
                {employeeName}
            </td>
            <td style={tdStyles(usedTheme)}>{assigned || '—'}</td>
            <td style={tdStyles(usedTheme)}>
                {status ? (
                    <span
                        style={{
                            fontSize: '10px',
                            fontWeight: 600,
                            color: borderColor || '#666',
                            border: `1px solid ${borderColor || '#999'}`,
                            borderRadius: 10,
                            padding: '2px 8px',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {status}
                    </span>
                ) : '—'}
            </td>
        </tr>
    );
};

const tdStyles = (usedTheme) => ({
    padding: `${Spacing.SCALE_8}px ${Spacing.SCALE_8}px`,
    fontSize: '12px',
    borderBottom: `1px solid ${usedTheme?.BORDER_COLOR || 'lightgrey'}`,
    whiteSpace: 'nowrap',
});

export default AdhocTaskTableRow;
